//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      isShow: false
    };
  },
  methods: {
    /**
     * 显示动画loading
     */
    show: function show() {
      this.isShow = true;
    },

    /**
    * 隐藏动画loading
    */
    hide: function hide() {
      this.isShow = false;
    }
  }
};